<template>
    <div class="order-summary">
        <div class="order-summary__header">
            <div class="order-summary__title text-center">
                Have questions?
            </div>
        </div>
        <div class="order-summary__profile">
            <div v-if="manager">
                <div class="order-summary__profile-title">
                    Ask your account manager<br>
                    {{ manager.name }}
                </div>
                <ul class="order-summary__profile-list">
                    <li>{{ manager.email }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      manager: 'companies/accountManager',
    }),
  },
};
</script>
